/**
 * PreviewRankBadge — compact #N rank label for preview overlay rows.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

export interface PreviewRankBadgeProps {
  rank?: number;
}

const PreviewRankBadge: FC<PreviewRankBadgeProps> = ({ rank }) => (
  <span
    className="text-[10px] font-semibold tabular-nums text-muted-foreground"
    aria-label={rank != null ? `Rank ${rank}` : undefined}
  >
    {rank != null ? `#${rank}` : '—'}
  </span>
);

export default PreviewRankBadge;
